// extracted by mini-css-extract-plugin
export var formContainer = "styles-module__formContainer___pM1Wu";
export var formSection = "styles-module__formSection___gydJz";
export var header = "styles-module__header___CCMp4";